/* B-JMC™ — Menu sur téléphone :
   1) « Boutique » : un toucher ouvre d'abord la liste des collections au lieu d'aller directement à la page.
   2) La barre du haut (6 liens) reste toujours sur UNE ligne : la taille du texte s'ajuste automatiquement à la largeur de l'écran. */
(function () {
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
  var TOP = '.header__inline-menu menu-dropdown > a.header__menu-item--top';

  /* ---------- Ajustement de la taille du texte ---------- */
  function fit() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    var ul = nav.querySelector('.list-menu--inline');
    if (!ul) return;
    if (!MQ.matches) { nav.style.removeProperty('--bjmc-menu-fs'); nav.removeAttribute('data-bjmc-fit'); return; }
    nav.setAttribute('data-bjmc-fit', '1');
    var size = 13;
    nav.style.setProperty('--bjmc-menu-fs', size + 'px');
    var avail = nav.clientWidth;
    if (!avail) return;
    while (size > 6 && ul.scrollWidth > avail + 0.5) {
      size -= 0.25;
      nav.style.setProperty('--bjmc-menu-fs', size + 'px');
    }
  }
  var t = null;
  function fitSoon() { clearTimeout(t); t = setTimeout(fit, 60); }
  if (document.readyState !== 'loading') fit(); else document.addEventListener('DOMContentLoaded', fit);
  window.addEventListener('load', fit);
  window.addEventListener('resize', fitSoon);
  window.addEventListener('orientationchange', fitSoon);
  if (document.fonts) {
    if (document.fonts.ready) document.fonts.ready.then(fit);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitSoon);
  }
  if (MQ.addEventListener) MQ.addEventListener('change', fit);

  /* ---------- Liste « Boutique » au toucher ---------- */
  function closeAll(except) {
    var opened = document.querySelectorAll('.header__inline-menu menu-dropdown');
    for (var i = 0; i < opened.length; i++) {
      if (opened[i] !== except) { opened[i].classList.remove('is-active'); opened[i].removeAttribute('data-bjmc-open'); }
    }
  }

  // État AVANT le toucher (le thème peut ouvrir la liste au survol simulé juste avant le clic)
  document.addEventListener('pointerdown', function (e) {
    var link = e.target.closest ? e.target.closest(TOP) : null;
    if (link) link._bjmcWas = link.parentNode.classList.contains('is-active');
  }, true);

  document.addEventListener('click', function (e) {
    if (!MQ.matches) return;
    var link = e.target.closest ? e.target.closest(TOP) : null;
    if (link) {
      e.preventDefault();
      e.stopPropagation();
      var m = link.parentNode;
      var was = (typeof link._bjmcWas === 'boolean') ? link._bjmcWas : m.getAttribute('data-bjmc-open') === '1';
      link._bjmcWas = undefined;
      closeAll(m);
      if (was) { m.classList.remove('is-active'); m.removeAttribute('data-bjmc-open'); }
      else { m.classList.add('is-active'); m.setAttribute('data-bjmc-open', '1'); }
      return;
    }
    // Toucher en dehors de la liste : on la referme
    if (!(e.target.closest && e.target.closest('.header__inline-menu menu-dropdown'))) closeAll(null);
  }, true);

  // Touche Échap : referme la liste
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
